import { GET_PARCHI_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { ParchiGenericApiResponse } from "../types/parchi";

export default async function sendMrLink({
  patientOid,
}: {
  patientOid: string;
}): Promise<ParchiGenericApiResponse<undefined>> {
  try {
    const PARCHI_HOST = GET_PARCHI_HOST();
    let endpoint = `${PARCHI_HOST}/service/sendmrlink?patientid=${patientOid}&flavour=dw`;
    const res = await fetch(endpoint, {
      method: "GET",
      redirect: "follow",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return res.json();
  } catch (e) {
    return { success: false };
  }
}
